import React, { FC, useEffect, useState } from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useAuthContext, usePreferences } from '../../../../../data-access';
import { useUpdateEmailPref } from '../../../../../data-access/mutations';
import { AppSwitch } from '../../../../common';
import { SETTING_ICONS } from '../../../constants';
import './EmailSection.scss';

const ReportIcon = SETTING_ICONS.email;

const EmailSection: FC = () => {
  const { t } = useTranslation();
  const { user } = useAuthContext();
  const { emailPreferences } = usePreferences({ preferenceId: user.preferenceId! });
  const { updateEmailPref, isPending } = useUpdateEmailPref();
  const [weeklySummaryEnabled, setWeeklySummaryEnabled] = useState(true);

  useEffect(() => {
    setWeeklySummaryEnabled(emailPreferences.report?.weeklySummary ?? true);
  }, [emailPreferences.report?.weeklySummary]);

  const handleWeeklySummaryChange = (checked: boolean) => {
    if (!user.preferenceId) {
      return;
    }

    setWeeklySummaryEnabled(checked);
    updateEmailPref({
      preferenceId: user.preferenceId,
      preferences: {
        report: {
          weeklySummary: checked,
        },
      },
    }).catch(() => {
      setWeeklySummaryEnabled(!checked);
    });
  };

  return (
    <Stack gap={2} className="email-section">
      <Typography variant="h3" className="email-section__title">
        {t('settings.email.title')}
      </Typography>

      <div className="email-section__block">
        <Stack
          id="emailReport"
          className="email-section__group"
          gap={1}
          sx={{ scrollMarginTop: '12px' }}
        >
          <Stack gap={1} direction="row" alignItems="center" className="email-section__group-header">
            <ReportIcon className="email-section__group-icon" />
            <Typography variant="body1" className="email-section__group-title">
              {t('settings.email.report.title')}
            </Typography>
          </Stack>

          <Stack className="email-section__group-card">
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              className="email-section__list-item"
            >
              <Stack gap={0.5}>
                <Typography variant="body1" className="email-section__list-item-title">
                  {t('settings.email.report.weeklySummary.title')}
                </Typography>
                <Typography variant="subtitle2" className="email-section__list-item-description">
                  {t('settings.email.report.weeklySummary.description')}
                </Typography>
              </Stack>

              <AppSwitch
                checked={weeklySummaryEnabled}
                disabled={isPending}
                onChange={(event) => handleWeeklySummaryChange(event.target.checked)}
              />
            </Stack>
          </Stack>
        </Stack>
      </div>
    </Stack>
  );
};

export default EmailSection;
